import { toDateTimeLocal } from '../dateTime';
import { asString, parseEligibleRegionsField, parseObject, parseRequiredArrayField } from '../parseHelpers';

import { createDefaultSpendPointsTile } from './defaults';
import { createTileDraftLabel } from './tiles';
import type { SpendPointsPayloadBuilderState, SpendPointsWaysToBoostTile } from './types';

function parseTile(value: unknown, index: number): SpendPointsWaysToBoostTile {
  const source = parseObject(value, `Ways to Boost tile ${index + 1}`);
  const defaults = createDefaultSpendPointsTile(createTileDraftLabel(index));

  return {
    ...defaults,
    endAt: toDateTimeLocal(source.endAt),
    ctaUrl: asString(source.ctaUrl),
    imageId: asString(source.imageId),
    startAt: toDateTimeLocal(source.startAt),
    enabledRegions: parseEligibleRegionsField(source, `${defaults.draftLabel} Eligible Regions`),
    isActive: source.isActive === undefined ? defaults.isActive : source.isActive === true,
    title: asString(source['title-i18n']),
    ctaLabel: asString(source['ctaLabel-i18n']),
    description: asString(source['description-i18n']),
  };
}

export function parseSpendPointsPayload(value: unknown): SpendPointsPayloadBuilderState {
  const source = parseObject(value, 'Payload');
  const waysToBoostTiles = parseRequiredArrayField(source, 'waysToBoostTiles').map((tile, index) =>
    parseTile(tile, index),
  );

  return {
    mode: 'spendPoints',
    waysToBoostTiles,
  };
}
